import classNames from 'classnames';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useSite } from '../../contexts';

import Button from './Button';

import styles from '../../../styles/buttons/consent.module.css';

interface ConsentButtonProps {
    direction?: 'left' | 'right';
    color?: string | null;
    withoutStyle?: boolean;
    className?: string | null;
    onClick?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | null;
}

function ConsentButton({
    direction = 'left',
    color = null,
    className = null,
    withoutStyle = false,
    onClick = null,
    ...props
}: ConsentButtonProps) {
    const { setShowCookieConsent } = useSite();

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            setShowCookieConsent(true);
            if (onClick !== null) {
                onClick(e);
            }
        },
        [onClick, setShowCookieConsent],
    );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles[direction]]: direction !== null,
                    [styles[color]]: color !== null,
                    [styles.withoutStyle]: withoutStyle,
                },
            ])}
            {...props}
            onClick={handleClick}
        >
            <FormattedMessage
                description="Button label"
                defaultMessage="Paramètres de confidentialité"
            />
        </Button>
    );
}

export default ConsentButton;
